import VideoSeachComponents from "./video-search-component";
const VideoSearch = () => {
  return (
    <div>
      <VideoSeachComponents />
    </div>
  );
};
export default VideoSearch;
